import React from 'react'

import type { ButtonElementState } from 'EditorApp/types'
import RenderedSvgElement from 'components/RenderedSvgElement'

interface Props {
  readonly element: ButtonElementState
}

const ButtonElement = ({ element }: Props) => {
  return (
    <RenderedSvgElement
      name="ButtonElement"
      id={element.id}
      svg={element.renderedSvg}
    />
  )
}

export default ButtonElement
